module.exports = __webpack_public_path__ + "img/2012-2.fac63c5e.jpg";